module.exports = __webpack_public_path__ + "img/calendar-black.3fd7c059.svg";